import { IPaginatedListTotalCountType } from '../types';
export const isSelfComputeListLength = (res) => res.totalCount < 0;
export const getComputedTotalCount = (res, pageSize = 10) => res.list.length < pageSize
    ? IPaginatedListTotalCountType.HAS_ENDED
    : IPaginatedListTotalCountType.HAS_MORE;
